import { FC } from "react";
import { StyledGroup } from "./style";

const TimelineGroup: FC = ({ children }) => {
    return <StyledGroup>{children}</StyledGroup>;
};

export default TimelineGroup;
